/* eslint-disable prettier/prettier */
//import css Bootstrap
//import 'bootstrap/dist/css/bootstrap.min.css';
// Default CSS theme splide
import '@splidejs/splide/css';
import '../css/glightbox.css';

import '../css/fonts.css';
import '../css/_variable.css';
//import yii css
import '../css/_site.css';
//import header css
import '../css/_header.css';
//import footer css
import '../css/_footer.css';
//import home css
import '../css/_home.css';
//import news css
import '../css/_news.css';
//import company css
import '../css/_company.css';
//import showroom css
import '../css/_showroom.css';
//import works css
import '../css/_works.css';
//import contact css
import '../css/_contact.css';
//import product css
import '../css/_product.css';
//import form css
import '../css/_form.css';
//import wishlist css
import '../css/_wishlist.css';
//import results.css
import '../css/_results.css';
//import newslette subscription.css
import '../css/_nslSubscription.css';

// Import all of Bootstrap's JS
//import * as bootstrap from 'bootstrap'

console.log('[webpack bundle js]');

import SplideGallery from '../js/splideGallery.js';
//Yii2FormValidator
import Yii2Validator from '../js/Yii2FormValidator.js';
// Menu Toggle
import MenuToggle from '../js/menuToggle.js'
// YouTube Player
import IoYoutube from '../js/youtube.js'
// Glightbox
// Using a bundler like webpack
import LightBox from '../js/glightbox.js';
// Search
// YouTube Player
import Search from '../js/search.js'

//import NslSubscription
import NslSubscription from "../js/NslSubscription.js";

//import Text Animation
import TextAnimation from '../js/TextAnimation.js';

//import Animate Image
import AnimateImage from '../js/AnimateImage.js';

//import Animate Block
import AnimateBlock from '../js/AnimateBlock.js';

//gestione modale newsletter
NslSubscription.init();

    console.log('DOM pronto');
    
    const form = document.getElementById('formRequest');
    console.log('form trovato:', form);
    
    new Yii2Validator('formRequest');

MenuToggle.init();
LightBox.init();
Search.init();

const playerEl = document.getElementById('player');
if (playerEl) {
    IoYoutube.showVideo(playerEl);
}

// START GESTIONE SPLIDE GALLERY
const showroom = document.querySelector('.showroom-splide');
if(showroom){ 
    SplideGallery.showroom(showroom);
}
const workslide = document.querySelector('.work-splide');
if(workslide){ 
    SplideGallery.showroom(workslide);
}
const productSlide = document.querySelector('.product-splide');
if(productSlide){
    SplideGallery.product(productSlide);
}
const newsSlide = document.querySelector('.news-slide');
if(newsSlide){
    SplideGallery.news(newsSlide);
}

//initialize textAnimation
TextAnimation.init();

AnimateImage.init();

AnimateBlock.init();

//import HEadroom
import Headroom from  '../js/headRoom.js';
var myElement = document.querySelector("header");
// construct an instance of Headroom, passing the element
var headroom  = new Headroom(myElement);// initialise
headroom.init();
